import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import { ActionPayload, DataLakeDirectoryDeleteRequestInput } from '../gql-types.generated';

// eslint-disable-next-line @typescript-eslint/naming-convention
const MUTATION_DELETE_DIRECTORY = gql`
    mutation deleteDataLakeDirectory ($input: DataLakeDirectoryDeleteRequestInput!){
        deleteDataLakeDirectory(input: $input) {
            message
            errors {
                code
                message
            }
            result
            data
        }
    }
`;

export const MutationDeleteDataLakeDirectory = async (
    client: ApolloClient<NormalizedCacheObject>,
    directoryFullPath: string
    ): Promise<ActionPayload | undefined> => {
        const {data, errors } = await client.mutate<{deleteDataLakeDirectory: ActionPayload}>({
            variables: {
                input: {
                    directoryFullPath
                } as DataLakeDirectoryDeleteRequestInput
            },
            mutation: MUTATION_DELETE_DIRECTORY
        });
        if (errors && errors.length > 0) {
            errors.forEach(error => {
                // Log error details in the console
                console.error(error);
            });
            // Friendly error to active user
            throw new Error('An error has occurred trying to delete the Data Lake directory.');
        }
        if (data && data.deleteDataLakeDirectory) {
            return data.deleteDataLakeDirectory;
        }
    
        return undefined;
    };